import Rectangle from "./Rectangle";

const RectanglesContainer = ({ rectanglesData, numRows }) => {
  // If numRows is 1, use flex layout, otherwise use grid
  const containerClassName =
    numRows === 1
      ? "flex flex-row gap-1 pl-4 w-fit"
      : "grid grid-cols-3 gap-1 p-4 pt-2 w-fit";

  return (
    <div className={containerClassName}>
      {rectanglesData.map((shape, index) => (
        <Rectangle key={index} {...shape} />
      ))}
    </div>
  );
};

export default RectanglesContainer;
